import { render, staticRenderFns } from "./LanguagesTranslationsSurveys.vue?vue&type=template&id=790e31ee&scoped=true&"
import script from "./LanguagesTranslationsSurveys.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsSurveys.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsSurveys.vue?vue&type=style&index=0&id=790e31ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790e31ee",
  null
  
)

export default component.exports